import { render, staticRenderFns } from "./examinationList.vue?vue&type=template&id=1c87e4a2&scoped=true&"
import script from "./examinationList.vue?vue&type=script&lang=js&"
export * from "./examinationList.vue?vue&type=script&lang=js&"
import style0 from "./examinationList.vue?vue&type=style&index=0&id=1c87e4a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c87e4a2",
  null
  
)

export default component.exports